import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[fileDragDrop]'
})
export class FileDragNDropDirective {
  @Output() private filesChangeEmitter : EventEmitter<File[]> = new EventEmitter();
  
  @HostBinding('style.background') private background = '#FFFFFF';
  @HostBinding('style.border') private borderStyle = '2px dashed';
  @HostBinding('style.border-color') private borderColor = '#BDC4C7';
  @HostBinding('style.border-radius') private borderRadius = '8px';

  // border: 2px dashed #BDC4C7;
  // border-radius: 8px;

  constructor() { }

  @HostListener('dragover', ['$event']) public onDragOver(evt){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'eee';
    this.borderColor = '#047D26'; //047D26, 0070B9
    this.borderStyle = '3px solid';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#FFFFFF';
    this.borderColor = '#BDC4C7';
    this.borderStyle = '2px dashed';
  }

  @HostListener('drop', ['$event']) public onDrop(evt){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#FFFFFF';
    this.borderColor = '#BDC4C7';
    this.borderStyle = '2px dashed';
    let files = evt.dataTransfer.files;
    let valid_files : Array<File> = files;
    this.filesChangeEmitter.emit(valid_files);
  }
}
